export enum RegistryActionsEnum {
  REGISTRY_EXPORT_OKVED_GET = 'REGISTRY_EXPORT_OKVED_GET',
  REGISTRY_EXPORT_OKVED_GET_REQUEST = 'REGISTRY_EXPORT_OKVED_GET_REQUEST',
  REGISTRY_EXPORT_OKVED_GET_SUCCESS = 'REGISTRY_EXPORT_OKVED_GET_SUCCESS',
  REGISTRY_EXPORT_OKVED_GET_FAILURE = 'REGISTRY_EXPORT_OKVED_GET_FAILURE',
}
